import React from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

function privacypolicy() {
  const img: any = "/static/images/privacy_policy_bg.png";

  const imgAnimation = UseAnimation();

  const handleMouseMove = (e: any) => {
    const { clientX, clientY } = e;
    const moveX = clientX - window.innerWidth / 2;
    const moveY = clientY - window.innerHeight / 2;
    const offsetFactor = 15;
    imgAnimation.start({
      x: moveX / offsetFactor,
      y: moveY / offsetFactor,
    });
  };

  return (
    <div className="wrapper">
      <Header />

      <section className="key_visual">
        <motion.img
          // animate={imgAnimation}
          // onMouseMove={(e) => handleMouseMove(e)}
          src={img}
          alt="Privacy Policy"
          loading="lazy"
        />
        <div className="img-bg" />
      </section>

      <section className="sv_content black-content ">
        <div className="container">
          <div className="row">
            <div className="content-heading col-12">
              <h1 className="fw-bolder t-blue mb-4">DISCLAIMER</h1>
            </div>
            <div className="col-12 c-content">
              <p className="t-white c-text mb-4">
                ITP Asia Co., Ltd. (referred to as ITP below) knows that you
                care that your information is used and shared, and we appreciate
                your trust that we will do so carefully and sensibly. This
                notice describes our privacy policy. By visiting ITP website,
                you are accepting the practices described in this Privacy
                Notice.
              </p>
              <p className="t-blue c-text mb-4">
                What Personal Information About Customer Does ITP website
                Gather?
              </p>
              <p className="t-white c-text mb-3">
                The information we learn from customer helps us personalize and
                continually improve your ITP website experience. Here are the
                types of information we gather.
              </p>
              <ul>
                <li className="t-white c-text mb-2">
                  <span className="fw-bold">Information You Give Us :</span> We
                  receive and store any information you enter on our website or
                  give us in any other way. You can choose not to provide
                  certain information, but then you might not be able to take
                  advantage of our features. We use the information that you
                  provide for such purposes as responding to your request and
                  communicating with you.
                </li>
                <li className="t-white c-text mb-2">
                  <span className="fw-bold">Automatic Information : </span> We
                  receive and store certain types of information whenever you
                  interact with us. For example, like many websites, we use
                  "cookies," and we obtain certain types of information when
                  your web browser accesses ITP website or advertisement and
                  other content served by or on behalf of ITP on other websites.
                </li>
                <li className="t-white c-text mb-2">
                  <span className="fw-bold">E-mail Communications : </span> To
                  help us make e-mail more useful and interesting, we often
                  receive a confirmation when you open e-mail from ITP if your
                  computer supports such capabilities. We also compare our
                  customer list to list received from other company, in an
                  effort to avoid sending unnecessary message to our customer.
                </li>
                <li className="t-white c-text mb-2">
                  <span className="fw-bold">
                    Information from Other Sources :{" "}
                  </span>{" "}
                  We might receive information about you from other sources and
                  add it to our account information.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content ">
        <div className="container">
          <div className="row">
            <div className="content-heading col-12">
              <h1 className="fw-bolder t-darkblue mb-4">WHAT ABOUT COOKIES?</h1>
            </div>
            <div className="col-12 c-content">
              <p className="c-text mb-4">
                Cookies are unique identifiers that we transfer to your device
                to enable our system to recognize your device and to provide
                feature such as purchasing, personalized language on websites.
                The Help feature on most browsers will tell you how to prevent
                your browser from accepting new cookies, how to have the browser
                notify you when you receive a new cookie, or how to disable
                cookies altogether. Additionally, you can disable or delete
                similar data used by browser add-ons, such as Flash cookies, by
                changing the add-on's settings or visiting the websites of its
                manufacturer. Because cookies allow you to take advantage of
                some of ITP website essential features, we recommend that you
                leave them turned on. For instance, if you block or otherwise
                reject our cookies, you will not be able to add items again, or
                use any ITP website products and services that require you to
                Sign in.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content ">
        <div className="container">
          <div className="row">
            <div className="content-heading col-12">
              <h1 className="fw-bolder t-blue mb-4">
                DOES ITP SHARE THE INFORMATION IT RECEIVES?
              </h1>
            </div>
            <div className="col-12 c-content">
              <p className="t-white c-text mb-4">
                Information about our customer is an important part of our
                business, and we are not in the business of selling it to
                others. We share customer information only as described below
                and with subsidiaries of ITP to control that either are subject
                to this Privacy Policy or follow practices at least as
                protective as those described in this Privacy Policy.
              </p>
              <ul>
                <li className="t-white c-text mb-2">
                  <span className="fw-bold">Promotional Offers :</span>
                  Sometimes we send offer to selected group of ITP’s customer on
                  behalf of other businesses. When we do this, we do not give
                  that business your name and address.
                </li>
                <li className="t-white c-text mb-2">
                  <span className="fw-bold">Protection of ITP website : </span>
                  We release account and other personal information when we
                  believe release is appropriate to comply with the law; enforce
                  or apply our Term & Condition and other agreements; or protect
                  the rights, property, or safety of ITP website and our users.
                  This includes exchanging information with other company and
                  organization for fraud protection and credit risk reduction.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content ">
        <div className="container">
          <div className="row">
            <div className="content-heading col-12">
              <h1 className="fw-bolder t-darkblue mb-4">
                HOW SECURE IS INFORMATION ABOUT ME?
              </h1>
            </div>
            <div className="col-12 c-content">
              <ul>
                <li className="c-text mb-2">
                  We work to protect the security of your information during
                  transmission by using Secure Sockets Layer (SSL) software,
                  which encrypts information you input.
                </li>
                <li className="c-text mb-2">
                  It is important for you to protect against unauthorized access
                  to your password (if any) and to your computer. Be sure to
                  sign off when finished using a shared computer.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content ">
        <div className="container">
          <div className="row">
            <div className="content-heading col-12">
              <h1 className="fw-bolder t-blue mb-4">
                WHICH INFORMATION CAN I ACCESS?
              </h1>
            </div>
            <div className="col-12 c-content">
              <p className="t-white c-text mb-4">
                ITP website gives you access to a broad range of information
                about your account (if any) and your interaction with ITP for
                the limited purpose of viewing, download and in certain cases,
                updating information.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content ">
        <div className="container">
          <div className="row">
            <div className="content-heading col-12">
              <h1 className="fw-bolder t-darkblue mb-4">
                WHAT CHOICES DO I HAVE?
              </h1>
            </div>
            <div className="col-12 c-content">
              <p className="c-text mb-4">
                Information about our customer is an important part of our
                business, and we are not in the business of selling it to
                others. We share customer information only as described below
                and with subsidiaries of ITP to control that either are subject
                to this Privacy Policy or follow practices at least as
                protective as those described in this Privacy Policy.
              </p>
              <ul>
                <li className="c-text mb-2">
                  As discussed above, you can always choose not to provide
                  information, even though it might be needed to take advantage
                  of such ITP website features as News & Update, communication
                  with ITP etc.
                </li>
                <li className="c-text mb-2">
                  The Help feature on most browsers will tell you how to prevent
                  your browser from accepting new cookies, how to have the
                  browser notify you when you receive a new cookie, or how to
                  disable cookies altogether. Additionally, you can disable or
                  delete similar data used by browser add-ons, such as Flash
                  cookies, by changing the add-on's settings or visiting the
                  websites of its manufacturer. Because cookies allow you to
                  take advantage of some of ITP website essential features, we
                  recommend that you leave them turned on. For instance, if you
                  block or otherwise reject our cookies, you will not be able to
                  use any ITP website products and services that require you to
                  Sign in.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content ">
        <div className="container">
          <div className="row">
            <div className="content-heading col-12">
              <h1 className="fw-bolder t-blue mb-4">
                ARE CHILDREN ALLOWED TO ACCESS ITP WEBSITE?
              </h1>
            </div>
            <div className="col-12 c-content">
              <p className="t-white c-text mb-4">
                ITP website does not provide information for children.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content ">
        <div className="container">
          <div className="row">
            <div className="content-heading col-12">
              <h1 className="fw-bolder t-darkblue mb-4">
                Conditions of Use, Notice, and Revision
              </h1>
            </div>
            <div className="col-12 c-content">
              <p className="c-text mb-4">
                If you choose to visit ITP website, your visit and any dispute
                over privacy is subject to this Notice and our Term and
                Condition, including limitation on damage, resolution of
                dispute, and application of the law of Thailand. If you have any
                concern about privacy at ITP website, please contact us with a
                thorough description, and we will try to resolve it. Our
                business changes constantly, and our Privacy Policy and the Term
                & Condition will change also. We may e-mail periodic reminder of
                our notice and condition, but you should check our websites
                frequently to see recent changes. Unless stated otherwise, our
                current Privacy Notice applies to all information that we have
                about you and your account (if any). We stand behind the
                promises we make, however, and will never materially change our
                policies and practices to make them less protective of customer
                information collected in the past without the consent of
                affected customer.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer/>
    </div>
  );
}

export default privacypolicy;
